<script>
import VueTagsInput from '@johmun/vue-tags-input'
import AddNewUsers from '@adminUsers/mixins/add-new-users-group.vue'
import AddMembers from '@adminGroups/mixins/add-members.vue'

export default {
  components: {
    VueTagsInput,
  },
  mixins: [AddNewUsers, AddMembers],
  props: {
    companyId: { type: [String, Number], required: true },
    groupId: { type: [String, Number], required: false, default: null },
  },
  data() {
    return {
      invitesDefault: [],
      invites: [],
      errorFlag: false,

      userTag: '',
      userTags: [],
      userDisplayTags: [],
      groupTag: '',
      groupTags: [],
      groupDisplayTags: [],

      uploadFile: '',
      uploadFileName: '',
    }
  },
  watch: {
    userTag: 'searchUsers',
    groupTag: 'searchGroups',
  },
  methods: {
    addNewUsersEvent() {
      this.addNewUsers(() => this.$emit('refresh-members-table'))
    },
    updateUserTags(newTags) {
      this.userDisplayTags = []
      this.userTags = newTags
    },
    updateGroupTags(newTags) {
      this.groupDisplayTags = []
      this.groupTags = newTags
    },
    uploadUserFile() {
      const file = this.$refs.file.files[0]
      this.uploadFileName = file.name
      this.uploadFile = file
    },
    onUploadClick() {
      this.$refs.file.click()
    },
  },
}
</script>

<template>
  <div class="pt-16 w-2/3 mx-auto">
    <div>
      <h3 class="text-2xl text-blue-darker mb-1">Add Users</h3>
      <button
        class="button secondary-button text-left text-lg mb-2"
        @click="inviteUser"
      >
        Add new +
      </button>
    </div>

    <div v-if="invites.length" class="mb-8">
      <div v-for="(user, index) in invites" :key="index" class="flex mb-3">
        <div class="w-1/2 pr-12">
          <BaseInputText v-model="invites[index].name" placeholder="Name" />
        </div>
        <div class="w-1/2 pr-12">
          <BaseInputText v-model="invites[index].email" placeholder="Email" />
        </div>
      </div>
      <div v-if="errorFlag" class="mb-3 text-sm errors text-volunteer_red">
        Please fill in the user name and email.
      </div>
      <button
        class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
        @click="addNewUsersEvent"
      >
        Send Invitations
      </button>
    </div>

    <div class="flex mb-8">
      <div class="w-1/2 pr-12">
        <label for="searchStr" class="block mb-3">Individual Users:</label>
        <VueTagsInput
          v-model="userTag"
          :tags="userTags"
          :autocomplete-items="userDisplayTags"
          :add-only-from-autocomplete="true"
          :add-on-blur="false"
          placeholder="Search for individual users"
          @tags-changed="updateUserTags"
        />
      </div>
      <div class="w-1/2 pr-12">
        <label for="searchStr" class="block mb-3"
          >All users from a group:</label
        >
        <VueTagsInput
          v-model="groupTag"
          :tags="groupTags"
          :autocomplete-items="groupDisplayTags"
          :add-only-from-autocomplete="true"
          :add-on-blur="false"
          placeholder="Search for group"
          @tags-changed="updateGroupTags"
        />
      </div>
    </div>

    <div class="">
      <label for="uploadUser" class="block mb-3">
        Upload New Users:
        <span class="text-gray">Add Users From a CSV File</span>
      </label>
      <div class="w-1/2 relative pr-12 overflow-hidden" @click="onUploadClick">
        <div class="bg-gray h-8 rounded-full flex items-center">
          <div class="w-full text-gray pl-5 cursor-default">
            {{ uploadFileName ? uploadFileName : 'Choose File' }}
          </div>
          <input
            ref="file"
            type="file"
            name="uploadUser"
            class="input opacity-0"
            @change="uploadUserFile"
          />
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="18"
          height="18"
          viewBox="0 0 471.2 471.2"
          class="absolute right-0 top-0 mt-2 mr-16"
          style="enable-background:new 0 0 471.2 471.2;"
        >
          <g>
            <g>
              <path
                d="M457.7,230.15c-7.5,0-13.5,6-13.5,13.5v122.8c0,33.4-27.2,60.5-60.5,60.5H87.5c-33.4,0-60.5-27.2-60.5-60.5v-124.8
        c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v124.8c0,48.3,39.3,87.5,87.5,87.5h296.2c48.3,0,87.5-39.3,87.5-87.5v-122.8
        C471.2,236.25,465.2,230.15,457.7,230.15z"
                fill="#069BD7"
              />
              <path
                d="M159.3,126.15l62.8-62.8v273.9c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5V63.35l62.8,62.8c2.6,2.6,6.1,4,9.5,4
        c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.8-85.8c-2.5-2.5-6-4-9.5-4c-3.6,0-7,1.4-9.5,4l-85.8,85.8
        c-5.3,5.3-5.3,13.8,0,19.1C145.5,131.35,154.1,131.35,159.3,126.15z"
                fill="#069BD7"
              />
            </g>
          </g>
        </svg>
      </div>
    </div>

    <button
      class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
      @click="addSearchUser"
    >
      Add selected users to Group
    </button>
  </div>
</template>
